import { get } from './client';

/**
 * 
 * @param {*} id 
 * @returns 
 */
export function getOneMerchantTheme(id) {
    return get('merchanttheme/' + id)
}
